export default __webpack_public_path__ + "static/media/PurgatoryCover.5af0269f.png";